import { create } from "zustand";
import { AuthStoreState } from "../../store/auth/authState"; 
import { getEnvVar } from "../../Utility/Utility";
import axios from "axios";
import { axiosService, ServiceEndPoint } from "../common/Axios.service";
import { axiosInstance } from "../../core/auth/RequestInterceptor";

const SERVICE_URL=ServiceEndPoint.account_service;
export const authService =create<AuthStoreState>((set, get) => ({
    user: null,
    loading: true,
    isAuthenticated: false,
  
    //AuthProvider Store
    login: async (username?:string,password?:string) => {
      try {
        const credentials = {
          "username": username,
          "password": password
        }
        
        const response = await axiosInstance.post(`${SERVICE_URL}login`, credentials);
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('apiSessionStorage', response.data.apiSessionStorage);
        if(response.data.account){
           localStorage.setItem('account', '1');
        }
       
        
        set({
          isAuthenticated: true
        });
        return response;
      } catch (error) {
        console.error('Login failed:', error);
        set({ user: null });
        return null;
      }
    },
    switchAccount:async(account_code: string)=>{
      const payload= {
        "account": {
            "code": account_code
        }
      };
      const endPoint=ServiceEndPoint.account_service;
         const response=await axiosService.post(`${endPoint}set-account`,payload);
         if(response.data.token){
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('account', '1');
         }
         return response;
     },
    logout: async() => {
      localStorage.clear();
      set({ user: null });
    },
    autoLogin: async () => {
      const token = localStorage.getItem('token');
      const apiSessionStorage = localStorage.getItem('apiSessionStorage');
      console.log("in auto login", token)
      if (token && apiSessionStorage) {
        return true;
      }
  
    },
  }
  ));
  